import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	userId: string | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	userId: null,
};

const approveUnit = createSlice({
	name: 'approveUnit',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setUserId: (state, action: PayloadAction<{ userId: string }>) => {
			state.userId = action.payload.userId;
			state.page = initialState.page;
		},
		resetApproveUnit: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	setUserId,
	resetApproveUnit,
} = approveUnit.actions;

export default approveUnit.reducer;
